var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanelTextRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.279,
    height: 52,
    viewBox: "0 0 92.279 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(-9562.221 -2592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M41,24H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H41a1,1,0,0,1,1,1V23A1,1,0,0,1,41,24ZM16.5,6.375a.5.5,0,0,0-.5.5V18.124a.5.5,0,0,0,.5.5.492.492,0,0,0,.253-.07l9.517-5.624a.5.5,0,0,0,0-.86L16.754,6.446A.492.492,0,0,0,16.5,6.375Z",
    transform: "translate(9562.221 2592)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9618.221 2592)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9618.221 2604)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9618.221 2617)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9618.221 2629)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9618.221 2641)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelTextRight);
export default __webpack_public_path__ + "static/media/panel-text-right.5ecf4763ec9fcb0810642193d0d4e21b.svg";
export { ForwardRef as ReactComponent };